<div class="communications-center">
  <h3>AUTOMATED COMMUNICATIONS CENTER</h3>
  <p class="hint">
    The RX Expiration reminder is the first template and rule.
    Edit the letter under TEMPLATES, turn the daily send on or off under RULES,
    and review failed emails under EXCEPTIONS.
  </p>

  <div class="alert" *ngIf="status?.alerts?.length">
    <div *ngFor="let alert of status.alerts">{{ alert }}</div>
  </div>

  <mat-tab-group animationDuration="0">
    <mat-tab label="TEMPLATES">
      <div class="tab-body" fxLayout="row" fxLayoutGap="24px" fxLayout.lt-md="column">
        <div fxFlex="280px">
          <button mat-stroked-button type="button" (click)="newTemplate()">NEW TEMPLATE</button>
          <button
            class="template-link"
            type="button"
            *ngFor="let row of templates"
            [class.active]="row._id === selectedTemplate?._id"
            (click)="selectTemplate(row)"
          >
            <div>{{ row.name }}</div>
            <div class="meta">{{ row.category }} · {{ row.channel }} · {{ row.status }}</div>
          </button>
        </div>
        <div fxFlex>
          <div class="summary-title">{{ selectedTemplate?.name || 'TEMPLATE' }}</div>
          <div fxLayout="row wrap" fxLayoutGap="12px">
            <mat-form-field fxFlex>
              <mat-label>NAME</mat-label>
              <input matInput [(ngModel)]="selectedTemplate.name" autocomplete="off">
            </mat-form-field>
            <mat-form-field fxFlex>
              <mat-label>CATEGORY</mat-label>
              <mat-select [(ngModel)]="selectedTemplate.category">
                <mat-option *ngFor="let item of categories" [value]="item">{{ item }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field fxFlex>
              <mat-label>CHANNEL</mat-label>
              <mat-select [(ngModel)]="selectedTemplate.channel">
                <mat-option *ngFor="let item of channels" [value]="item">{{ item }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field fxFlex>
              <mat-label>STATUS</mat-label>
              <mat-select [(ngModel)]="selectedTemplate.status">
                <mat-option *ngFor="let item of templateStatuses" [value]="item">{{ item }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-form-field style="width:100%">
            <mat-label>SUBJECT</mat-label>
            <input matInput [(ngModel)]="selectedTemplate.subject" autocomplete="off">
          </mat-form-field>
          <mat-form-field style="width:100%">
            <mat-label>PREVIEW TEXT</mat-label>
            <input matInput [(ngModel)]="selectedTemplate.previewText" autocomplete="off">
          </mat-form-field>
          <div fxLayout="row wrap" fxLayoutGap="12px">
            <mat-form-field fxFlex>
              <mat-label>SENDER NAME</mat-label>
              <input matInput [(ngModel)]="selectedTemplate.fromName" autocomplete="off">
            </mat-form-field>
            <mat-form-field fxFlex>
              <mat-label>FROM EMAIL</mat-label>
              <input matInput [(ngModel)]="selectedTemplate.fromAddress" autocomplete="off">
            </mat-form-field>
            <mat-form-field fxFlex>
              <mat-label>REPLY TO</mat-label>
              <input matInput [(ngModel)]="selectedTemplate.replyTo" autocomplete="off">
            </mat-form-field>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="12px">
            <mat-form-field fxFlex>
              <mat-label>LOGO URL</mat-label>
              <input matInput [(ngModel)]="selectedTemplate.logoUrl" autocomplete="off">
            </mat-form-field>
            <mat-form-field fxFlex>
              <mat-label>HEADER COLOR</mat-label>
              <input matInput [(ngModel)]="selectedTemplate.headerColor" autocomplete="off">
            </mat-form-field>
          </div>
          <mat-form-field style="width:100%">
            <mat-label>BODY</mat-label>
            <textarea matInput rows="10" [(ngModel)]="selectedTemplate.body"></textarea>
          </mat-form-field>
          <mat-form-field style="width:100%">
            <mat-label>FOOTER</mat-label>
            <textarea matInput rows="3" [(ngModel)]="selectedTemplate.footer"></textarea>
          </mat-form-field>
          <p class="hint">
            Placeholders: {{ '{{firstName}}' }}, {{ '{{expirationDate}}' }},
            {{ '{{appointmentLink}}' }}, {{ '{{storeName}}' }}, {{ '{{storePhone}}' }},
            {{ '{{storeAddress}}' }}, {{ '{{jobList}}' }}, {{ '{{unsubscribeUrl}}' }}.
            Do not include prescription values.
          </p>
          <p class="hint" *ngIf="selectedTemplate.version">
            Version {{ selectedTemplate.version }}
            <span *ngIf="selectedTemplate.lastEditorName"> · {{ selectedTemplate.lastEditorName }}</span>
            <span *ngIf="selectedTemplate.testedAt"> · tested {{ formatDate(selectedTemplate.testedAt) }}</span>
          </p>
          <mat-form-field>
            <mat-label>TEST EMAIL</mat-label>
            <input matInput [(ngModel)]="testEmail" autocomplete="off">
          </mat-form-field>
          <button mat-raised-button color="primary" type="button" [disabled]="saving" (click)="saveTemplate()">
            SAVE TEMPLATE
          </button>
          <button mat-stroked-button type="button" [disabled]="testing" (click)="testTemplate()">
            SEND TEST EMAIL
          </button>

          <div class="summary-title">PREVIEW</div>
          <button mat-button type="button" (click)="previewMode = 'desktop'; refreshPreview()">DESKTOP</button>
          <button mat-button type="button" (click)="previewMode = 'mobile'; refreshPreview()">MOBILE</button>
          <div class="preview-frame" [class.mobile]="previewMode === 'mobile'" [innerHTML]="previewHtml"></div>

          <div class="summary-title" *ngIf="selectedTemplate.versions?.length">VERSION HISTORY</div>
          <table class="comm-table" *ngIf="selectedTemplate.versions?.length">
            <tr *ngFor="let row of selectedTemplate.versions">
              <td>v{{ row.version }}</td>
              <td>{{ formatDate(row.savedAt) }}</td>
              <td>{{ row.editorName }}</td>
              <td>
                <button mat-button type="button" (click)="restoreVersion(row.version)">RESTORE</button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="RULES">
      <div class="tab-body" fxLayout="row" fxLayoutGap="24px" fxLayout.lt-md="column">
        <div fxFlex="280px">
          <button
            class="template-link"
            type="button"
            *ngFor="let row of rules"
            [class.active]="row._id === selectedRule?._id"
            (click)="selectRule(row)"
          >
            <div>{{ row.name }}</div>
            <div class="meta">{{ row.trigger }} · {{ row.status }}</div>
          </button>
        </div>
        <div fxFlex *ngIf="selectedRule">
          <div class="summary-title">{{ selectedRule.name }}</div>
          <p class="hint">
            Estimated recipients right now: <strong>{{ estimate }}</strong>
          </p>
          <mat-form-field style="width:100%">
            <mat-label>NAME</mat-label>
            <input matInput [(ngModel)]="selectedRule.name" autocomplete="off">
          </mat-form-field>
          <mat-form-field style="width:100%">
            <mat-label>TEMPLATE</mat-label>
            <mat-select [(ngModel)]="selectedRule.templateId">
              <mat-option *ngFor="let row of templates" [value]="row._id">{{ row.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>DAYS BEFORE</mat-label>
            <input matInput type="number" [(ngModel)]="selectedRule.timingDays">
          </mat-form-field>
          <mat-checkbox [(ngModel)]="selectedRule.recurring">RECURRING</mat-checkbox>
          <p class="hint">
            One event produces one patient message. Pause keeps history.
            A new rule cannot become Active until a test email is sent.
          </p>
          <button mat-raised-button color="primary" type="button" (click)="saveRule()">SAVE RULE</button>
          <button mat-stroked-button type="button" (click)="activateRule()">ACTIVATE</button>
          <button mat-stroked-button type="button" (click)="pauseRule()">PAUSE</button>
          <button mat-stroked-button type="button" [disabled]="running" (click)="runNow()">
            RUN DUE MESSAGES
          </button>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="QUEUE / LOG">
      <div class="tab-body">
        <mat-form-field>
          <mat-label>STATUS</mat-label>
          <mat-select [(ngModel)]="sendFilter" (selectionChange)="loadSends()">
            <mat-option *ngFor="let item of sendStatuses" [value]="item">
              {{ item || 'ALL' }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <p *ngIf="!sends.length">No communication records yet.</p>
        <table class="comm-table" *ngIf="sends.length">
          <thead>
            <tr>
              <th>STATUS</th>
              <th>PATIENT</th>
              <th>CHANNEL</th>
              <th>TEMPLATE</th>
              <th>RULE</th>
              <th>SENT</th>
              <th>RESULT</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of sends">
              <td>{{ row.status }}</td>
              <td>{{ patientName(row) }}</td>
              <td>{{ row.channel }}</td>
              <td>{{ templateName(row.template) }}</td>
              <td>{{ row.rule }}</td>
              <td>{{ formatDate(row.sentAt || row.scheduledAt) }}</td>
              <td>{{ row.result || row.error }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </mat-tab>

    <mat-tab label="EXCEPTIONS">
      <div class="tab-body">
        <p class="hint">
          Failed, bounced, complained, and missing-contact sends stay here.
          Correct the address on the patient record. AutoOptiq does not retry
          until the contact information is valid.
        </p>
        <p *ngIf="!exceptions.length">No exceptions.</p>
        <table class="comm-table" *ngIf="exceptions.length">
          <thead>
            <tr>
              <th>STATUS</th>
              <th>PATIENT</th>
              <th>CONTACT</th>
              <th>RULE</th>
              <th>RESULT</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of exceptions">
              <td>{{ row.status }}</td>
              <td>{{ patientName(row) }}</td>
              <td>{{ row.email || row.phone }}</td>
              <td>{{ row.rule }}</td>
              <td>{{ row.error || row.result }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </mat-tab>

    <mat-tab label="AUDIT">
      <div class="tab-body">
        <p *ngIf="!audit.length">No audit history yet.</p>
        <table class="comm-table" *ngIf="audit.length">
          <thead>
            <tr>
              <th>WHEN</th>
              <th>ACTION</th>
              <th>ITEM</th>
              <th>EDITOR</th>
              <th>DETAIL</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of audit">
              <td>{{ formatDate(row.dateAdded) }}</td>
              <td>{{ row.action }}</td>
              <td>{{ row.entity }} {{ row.entityId }}</td>
              <td>{{ row.editorName }}</td>
              <td>{{ row.details }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
